export default __webpack_public_path__ + "static/media/upload.3bafc95a.svg";